<template>
    <div class="mit-my-reservations-page mit-page">
        <v-container fluid>
        <v-row no-gutters>
          <v-col cols="12" class="d-flex">
            <v-card class="mit-info-card">
              <v-card-title>My Reservations 
                <v-spacer/>
                <BaseMitNewReserveButtons buttonText="New Reservation" linkBuilding32Text="Building 32" :linkBuilding32IsLocal="true" linkBuilding45Text="Building 45"/>
              </v-card-title>
              <v-card-subtitle class="caption">Manage your reservations</v-card-subtitle>
              <v-divider></v-divider>

              <v-card-text>
                 <!-- <MitMyReservations :userModel="userModel"/> -->
                 <BaseMitMyReservations :userModel="userModel"/>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
</template>

<script>
//import MitMyReservations from '../components/MitMyReservations.vue';
  import BaseMitMyReservations from '../../base/components/reserve/BaseMitMyReservations.vue';
  import BaseMitNewReserveButtons from '../../base/components/reserve/BaseMitNewReserveButtons.vue';

  export default {
    name: 'MitMyReservationsPage',
    components: {
      BaseMitMyReservations,
      BaseMitNewReserveButtons
    },
    props: {
      userModel: Object, //comes from route
      userRoles: Object //comes from route
    },
    data: function() {
      return {

      }
    },
    mounted(){
    },
    methods : {
    }
  }
</script>

<style lang="scss" scoped>
.mit-info-card {
  width:100%;
  height:100%;
}
</style>
